module.exports = __webpack_public_path__ + "img/ccdsregmeetingtop.f0aaef32.png";